const moment = require('moment');

const dateFormat = (dateString) => moment(dateString).format('LL');
const dateFormat2 = (dateString) => moment(dateString).format('DD MMM YYYY');
const dateTimeFormat = (dateString) => moment(dateString).format('LLL');

export default { dateFormat, dateFormat2, dateTimeFormat };